var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[(_vm.paid)?_c('Purchased',{attrs:{"productSlug":_vm.product_slug}}):_c('Failed')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }